import { forwardRef } from "react";
import { Tooltip } from "@mui/material";
import LendyIcon from "./lendy/LendyIcon";
import "./WindowControls.css";

/**
 * Full screen and Close, top right of the sidebar. The sidebar draws the only window controls; the
 * web app draws none. The id is what older web apps read to place their own button beside Close.
 */
const WindowControls = forwardRef(({ isFullScreen, canToggleFullScreen, onToggleFullScreen, onClose }, ref) => {
  const fullScreenLabel = isFullScreen ? "Exit full screen" : "Full screen";

  return (
    <div id="addy-chat-close-button" ref={ref} className="window-controls">
      {canToggleFullScreen && (
        <Tooltip title={fullScreenLabel} arrow>
          <button type="button" className="window-control" aria-label={fullScreenLabel} onClick={onToggleFullScreen}>
            <LendyIcon name={isFullScreen ? "minimize" : "maximize"} />
          </button>
        </Tooltip>
      )}
      <Tooltip title="Close" arrow>
        <button type="button" className="window-control" aria-label="Close chat" onClick={onClose}>
          <LendyIcon name="x" />
        </button>
      </Tooltip>
    </div>
  );
});

export default WindowControls;
